import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import './PdfViewer.css';

const version = pdfjs.version;
const ext = version.startsWith('4') || version.startsWith('5') ? 'mjs' : 'js';
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${version}/build/pdf.worker.min.${ext}`;

export const PDFViewer = ({ fileUrl, onLoadError }) => {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
        setPageNumber(1);
    };

    return (
        <div className="pdf-viewer"
            style={{ width: '100%', overflowX: 'auto' }}>
            <Document
                file={fileUrl}
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={onLoadError}
                className="pdf-viewer-content"
                style={{ width: '100%', overflowX: 'auto', margin: 'auto' }}
                loading={<div style={{ textAlign: 'center', padding: '20px' }}>Загрузка PDF...</div>}
            >
                <Page pageNumber={pageNumber} width={1000} />
            </Document>
            {numPages > 1 && (
                <div className="pdf-controls">
                    <button
                        disabled={pageNumber <= 1}
                        onClick={() => setPageNumber(prev => prev - 1)}
                    >
                        Назад
                    </button>
                    <span>
                        {pageNumber} / {numPages}
                    </span>
                    <button
                        disabled={pageNumber >= numPages}
                        onClick={() => setPageNumber(prev => prev + 1)}
                    >
                        Вперёд
                    </button>
                </div>
            )}
        </div>
    );
};